import { getLocale } from 'next-intl/server'

import { getPropertyTypeMap } from '../../model/option'
import { TRoomDetail } from '../../model/schema'

export const generateRoomMetadata = async (
  room: Pick<
    TRoomDetail,
    'state' | 'province' | 'town' | 'propertyType' | 'roomName' | 'pictures'
  >,
) => {
  const [{ PROPERTY_TYPE_MAP }, locale] = await Promise.all([
    getPropertyTypeMap(),
    getLocale(),
  ])

  const propertyType = PROPERTY_TYPE_MAP[room.propertyType]

  const isEn = locale === 'en'

  const title = isEn
    ? `${room.province} ${room.town} ${propertyType} Short-Term Lease | ${room.roomName} | 33m2`
    : `${room.province} ${room.town} ${propertyType} 단기임대 | ${room.roomName} | 삼삼엠투`

  const description = isEn
    ? `Explore this ${propertyType} in ${room.province} ${room.town} on 33m2. Check photos, pricing, lease period, and move-in details, then sign your short-term lease in-app.`
    : `삼삼엠투에서 ${room.province} ${room.town}의 ${propertyType} 정보를 확인해보세요. 사진, 가격, 임대 기간, 입주 정보를 살펴보고 앱에서 단기임대 계약까지 진행할 수 있어요.`

  return {
    title,
    description,
    openGraph: {
      title,
      description,
      images: [
        `https://${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/${room.pictures[0]}`,
      ],
    },
  }
}
